/* eslint-disable indent */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText'
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import LocationOn from '@mui/icons-material/LocationOn';

import Add from '@mui/icons-material/Add';
import AttachMoney from '@mui/icons-material/AttachMoney';
import NoteAlt from '@mui/icons-material/NoteAlt';
import {
  AccessAlarm,
  AccountBox,
  Alarm,
  Delete,
  Error,
  ExpandLess,
  ExpandMore,
  Group,
  InfoOutlined,
  MoneyOff,
  MoreVert,
  PersonOff,
  QuestionMarkOutlined,
  Schedule,
  Settings,
  Task,
} from '@mui/icons-material';
import {
  Alert,
  Chip,
  Collapse,
  Divider,
  Icon,
  IconButton,
  ListItemButton,
  Menu,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import HorseIcon from '../../../../CustomIcons/Horse';
import BarnHorsesAutocomplete from '../../../../Autocompletes/BarnHorses';
import LocationsAutocomplete from '../../../../Autocompletes/Locations';
import BarnUsersAutocomplete from '../../../../Autocompletes/BarnUsers';

import { getBarnUsersForAssignmentString } from '../../../../../utils/scheduleHelper';
import {
  blueGrey,
  danger,
  grey,
  primary,
  secondary,
} from '../../../../../utils/brandColors';
import HorseBillablePrice from '../../../../EventData/HorseBillablePrice';
import HorseNote from '../../../../EventData/HorseNote';
import useDebounce from '../../../../../utils/useDebounce';
import UserMentionTextField from '../../../../UserMentionTextField';
import { getStatusItemSecondaryText } from '../../../../StatusAssignment';
import Horse from '../../../../Horse';
import TaskStatus from '../../../../TaskStatus';
import DueDate from '../../../../EventData/DueDate';
import CalendarEventDetailSettingsPage from '../../../../../pages/settings/CalendarEventDetailSettingsPage';
import LocationChip from '../../../../LocationChip';
import { getAvatarGroupForUsers } from '../../../../Planner/components/TaskCalendarOverview/components/TaskOverviewCell';

const TasksSection = ({
  schedule,
  event,
  eventTemplate,
  workflows,
  setWorkflows,
  validation,
  taskTagIds,
  barnHorses,
  location: propLocation,
  disabledForBeingInPast,
  setEventTemplate,
}) => {
  const navigate = useNavigate();
  const [selectedTaskAnchorEl, setSelectedTaskAnchorEl] = React.useState(false);
  const [selectedTaskIndex, setSelectedTaskIndex] = React.useState(-1);
  const [statusComment, setStatusComment] = React.useState('');
  const [showAddTaskInfo, setShowAddTaskInfo] = React.useState(false);
  const [initialWorkflowIndexSet, setInitialWorkflowIndexSet] = React.useState(false);
  const [openEditCalendarTypeModal, setOpenEditCalendarTypeModal] = React.useState(false);

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const locationsMap = useSelector((state) => state.location.locationsMap);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const statuses = useSelector((state) => state.status.statuses);
  const permissions = useSelector((state) => state.user.permissions);
  const eventData = useSelector((state) => state.eventData.eventData);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;

  const debouncedComment = useDebounce(statusComment, 500);

  React.useEffect(() => {
    setSelectedTaskIndex(-1)
    setStatusComment('');
    setShowAddTaskInfo(false)
    setInitialWorkflowIndexSet(false);
  }, [schedule, event])

  React.useEffect(() => {
    if (selectedTaskIndex >= 0) {
      const updatedWorkflows = workflows;
      updatedWorkflows[selectedTaskIndex].startingStatusComment = debouncedComment;
      setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
    }
  }, [debouncedComment])

  React.useEffect(() => {
    if (!initialWorkflowIndexSet) {
      const selectedWorkflow = workflows && workflows[selectedTaskIndex];
      if (!workflows || workflows.length === 0 || (selectedWorkflow && !workflows.find((w) => (`${w.tagIds}`) === (`${selectedWorkflow.tagIds}`)))) {
        // Remove selected workflow
        setSelectedTaskIndex(-1);
      } else if (event && event.workflowTagId && workflows && workflows.length > 0 && selectedTaskIndex < 0) {
        // find selected if passed in
        setSelectedTaskIndex(workflows.findIndex((w) => event && event.workflowTagId && `${w.tagIds}` === `${[event.workflowTagId]}`) || 0);
      } else {
        // Default to the last index
        setSelectedTaskIndex(workflows.length - 1);
      }
      setInitialWorkflowIndexSet(true);
    }
  }, [workflows])

  // const horseTagTypeId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0;
  const horseTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTaskTypeTagId) || 0;
  const barnTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.barnTaskTypeTagId) || 0;

  if (!eventTemplate) return <div />;

  return (
    <Grid
      container
      sx={{ mb: 2 }}
      spacing={2}
    >

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Task color="secondary" sx={{ mr: '2px' }} />
            <Typography
              variant="h5"
              sx={{
                color: validation.workflows
                  ? danger[500]
                  : 'default',
              }}
            >Tasks ({workflows.length})
            </Typography>

          </Box>
          <Tooltip
            title="Add Task"
          >
            <IconButton
              disabled={workflows.length > 0 && !!workflows.find((ww) => !ww.tagIds || ww.tagIds.length === 0)}
              onClick={() => {
                if (!workflows.find((ww) => ww.tagIds.length === 0 || ww.eventTemplateId === null)) {
                  // Only add if there are no other empty tasks
                  setSelectedTaskIndex(workflows.length)
                  const etToAdd = (eventTemplate.children && eventTemplate.children.length === 1)
                    ? eventTemplate.children[0]
                    : null

                  setWorkflows([...workflows, {
                    eventTemplateId: etToAdd
                      ? etToAdd.id
                      : null,
                    tagIds: (taskTagIds && taskTagIds.length === 1) // if we only have one horse just default select it
                      ? [taskTagIds[0].id]
                      : [],
                    createEvents: true,
                    startingAssignment: '',
                    dueDateStatusChangeId: (etToAdd || eventTemplate).dueDateStatusChangeId,
                    dueDateTime: (etToAdd || eventTemplate).dueDateDefaultTime || 0,
                    dueDateTimeEndOfDay: (etToAdd || eventTemplate).dueDateDefaultTimeEndOfDay || false,
                    eventDataDefaultValues: (etToAdd || eventTemplate).eventDataDefaultValues,
                  }]);
                }
              }}
            ><Add />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
      {
        (workflows.length === 0)
          ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    mt: 4,
                    mb: 1,
                    '&:hover': { cursor: 'pointer' },
                  }}
                  onClick={() => setShowAddTaskInfo(!showAddTaskInfo)}
                >
                  <InfoOutlined
                    color="secondary"
                    sx={{
                      height: 32,
                      width: 32,
                      mb: 1,
                    }}
                  />
                  <Typography sx={{ fontWeight: 300 }}>Why add tasks?</Typography>
                </Box>
                <Collapse in={showAddTaskInfo}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      maxWidth: 600,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        mb: 1,
                        textWrap: 'auto',
                      }}
                      gutterBottom
                    >
                      A Calendar Event itself is NOT used in reporting or other historical tracking (reminders) data. However,
                      any task added to an event will be.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        mb: 1,
                        textWrap: 'auto',
                      }}
                      gutterBottom
                    >
                      Tasks on events behave just like other tasks. Assigned users will see this in their task list, and
                      you will see these along side all other tasks in Questri.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        textWrap: 'auto',
                      }}
                    >
                      You can think of this as a wrapper around one or more different kinds of tasks. This allows you a different
                      way visualize and plan your schedule, involving people from both inside and outside your organization.
                    </Typography>
                  </Box>
                </Collapse>
              </Box>
            </Grid>
          )
          : (
            workflows.map((workflow, index) => {
              const w = workflows[selectedTaskIndex];
              const workflowStatus = statuses
                .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusId)))
              const workflowStatusComment = selectedTaskIndex >= 0
                && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusComment

              const horseTaskTypeTag = workflow && workflow.eventTemplateId && (eventTemplate.children
                .find((et) => et.id === workflow.eventTemplateId) || { tags: [] }).tags.find((t) => t.id === horseTaskTypeTagId);
              const barnTaskTypeTag = workflow && workflow.eventTemplateId && (eventTemplate.children
                .find((et) => et.id === workflow.eventTemplateId) || { tags: [] }).tags.find((t) => t.id === barnTaskTypeTagId);

              const ws = statuses
                .find((s) => s.id === ((index >= 0 && workflow.startingStatusId)))
              const wsc = index >= 0 && workflow.startingStatusComment
              const barnHorse = horseTaskTypeTag
                && ((workflow.tagIds && workflow.tagIds.length === 1 && barnHorsesMap[workflow.tagIds[0]]
                  && barnHorsesMap[workflow.tagIds[0]][0]) || null)
              const location = !barnHorse && barnTaskTypeTag
                && ((workflow.tagIds && workflow.tagIds.length === 1 && locationsMap[workflow.tagIds[0]]
                  && locationsMap[workflow.tagIds[0]][0]) || null);

              const workflowEventTemplate = eventTemplate && eventTemplate.children
                && (eventTemplate.children.find((et) => workflow.eventTemplateId && et.id === parseInt(workflow.eventTemplateId, 10)) || {
                  name: 'Select Task Type',
                  eventDataDefaultValues: { calendarDisplayColor: 'black' },
                });

              const dueDateTime = workflow.dueDateTime || 0
              const dueDateTimeEndOfDay = workflow.dueDateTimeEndOfDay || false;
              const billableValue = (workflow.eventDataDefaultValues
                || {})[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)];
              const billableReceivable = (workflow.eventDataDefaultValues || {})['Billable Receivable'] || 'yes';
              // const billableStatus = (workflow.eventDataDefaultValues || {})['Billable Status'] || 'Open';
              const horseNote = workflow.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]

              return (
                <Grid item xs={12} key={`workflow-container-${(workflow.tagIds && workflow.tagIds.join('')) || '0'}-${index}`}>
                  <Paper
                    elevation={2}
                    sx={{
                      padding: 1,
                      borderLeft: `8px solid ${workflowEventTemplate.eventDataDefaultValues
                        && workflowEventTemplate.eventDataDefaultValues.calendarDisplayColor}`,
                      borderTopLeftRadius: 8,
                      borderBottomLeftRadius: 8,

                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        '&:hover': {
                          opacity: '75%',
                          cursor: 'pointer',
                        },
                      }}
                      onClick={() => {
                        setSelectedTaskIndex(selectedTaskIndex === index
                          ? -1
                          : index);
                      }}
                    >
                      <Box
                        sx={{
                          pr: 1,
                          mr: 1,
                          borderRight: `1px solid ${blueGrey[50]}`,
                        }}
                      >
                        {
                          !barnHorse && !location && (
                            <Error
                              sx={{ width: 138 }}
                              color={
                                validation.workflows
                                  ? 'error'
                                  : 'warning'
                              }
                            />
                          )
                        }
                        {barnHorse
                          && (
                            <Horse
                              horse={barnHorse.horse}
                            />
                          )}
                        {location && (
                          <Box>
                            <LocationChip
                              location={location}
                            />
                          </Box>
                        )}
                      </Box>
                      <Grid container spacing={1} alignItems="center" sx={{ flex: 1 }} justifyContent="flex-end" flexWrap="wrap">
                        <Grid item>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Task
                              sx={{
                                mr: 1,
                                color: workflowEventTemplate.eventDataDefaultValues
                                  && workflowEventTemplate.eventDataDefaultValues.calendarDisplayColor,
                              }}
                            />
                            <Grid
                              container
                              sx={{
                                maxWidth: 80,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                              }}
                            >
                              {workflowEventTemplate.name}
                            </Grid>
                          </Box>
                        </Grid>
                        {
                          !!dueDateTime
                          && (
                            <Grid item>
                              <Tooltip
                                title={
                                  dueDateTimeEndOfDay
                                    ? 'Complete this task by end of day'
                                    : `Complete this task by ${moment(new Date(new Date().getTime() + dueDateTime)).fromNow().replace('in ', '')} from start`
                                }
                              >
                                <Alarm color="secondary" />
                              </Tooltip>
                            </Grid>
                          )
                        }
                        {
                          horseNote && (
                            <Grid item>
                              <Tooltip title="Creates a note on horse profile">
                                <NoteAlt color="secondary" />
                              </Tooltip>
                            </Grid>
                          )
                        }
                        {
                          billableValue && (
                            <Grid item>
                              <Tooltip title={`Creates a billing transaction on horse: $${billableValue}`}>
                                {
                                  billableReceivable === 'yes'
                                    ? <AttachMoney color="success" />
                                    : <MoneyOff color="secondary" />
                                }
                              </Tooltip>
                            </Grid>
                          )
                        }

                        {
                          ((ws && ws.id !== selectedBarn.barnMetadata.statusStartId) || wsc) && (
                            <Grid item>
                              <Chip
                                size="small"
                                color="primary"
                                icon={
                                  (ws || wsc)
                                    ? (
                                      <Icon
                                        sx={{ fontSize: '18px' }}
                                        color="primary"
                                      >{(ws && ws.icon) || eventTemplate.defaultStartStatus.icon}
                                      </Icon>
                                    )
                                    : (<Schedule sx={{ fontSize: '18px' }} color="primary" />)
                                }
                                label={(ws && ws.name) || (event && 'Scheduled') || 'Pending'}
                              />
                            </Grid>
                          )
                        }
                        {
                          workflow.scheduleAssignment && (
                            <Grid item>
                              <Tooltip title="Task Participants">
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: `1px solid ${secondary[500]}`,
                                    borderRadius: 20,
                                    gap: 0.5,
                                  }}
                                >
                                  <Group color="secondary" sx={{ paddingLeft: '2px' }} />
                                  {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.scheduleAssignment || '', barnUsersMap), '')}
                                </Box>
                              </Tooltip>
                            </Grid>
                          )
                        }
                        <Grid item>
                          <Tooltip
                            title={workflow.startingAssignment
                              ? 'Task Assignment'
                              : 'Unassigned Task'}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.startingAssignment || '', barnUsersMap), '')}
                              {
                                !workflow.startingAssignment && <PersonOff color="secondary" />
                              }
                            </Box>
                          </Tooltip>
                        </Grid>
                        <Grid item>
                          {selectedTaskIndex === index
                            ? <ExpandLess />
                            : <ExpandMore />}
                        </Grid>
                      </Grid>
                    </Box>
                    {
                      selectedTaskIndex === index && (
                        <Collapse in={selectedTaskIndex === index}>
                          <Box sx={{ height: '100%' }}>
                            <ListItemText
                              sx={{
                                backgroundColor: grey[50],
                                borderRadius: 4,
                                mt: 2,
                                mb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <TaskStatus
                                  eventStatus={{
                                    assignment: (workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingAssignment) || '',
                                    statusComment: workflowStatusComment,
                                    status: workflowStatus || {
                                      ...statuses.find((s) => s.id === selectedBarn.barnMetadata.statusStartId),
                                      name: 'Scheduled Task',
                                      statusIcon: 'schedule',
                                    },
                                  }}
                                  icon={(workflowStatus && workflowStatus.icon) || 'schedule'}
                                  color={primary[500]}
                                  archived={false}
                                  complete={!!(workflowStatus && workflowStatus.completeEvent)}
                                  scheduled
                                />
                                <Button
                                  size="small"
                                  sx={{ mr: 2 }}
                                  endIcon={<MoreVert />}
                                  onClick={(e) => {
                                    setSelectedTaskAnchorEl(e.currentTarget);
                                    setStatusComment(workflows[selectedTaskIndex].startingStatusComment || '')
                                  }}
                                  disabled={disabledForBeingInPast}
                                >
                                  Actions
                                </Button>
                              </Box>
                            </ListItemText>

                            <ListItem dense sx={{ px: 0 }}>
                              <ListItemIcon><Task /></ListItemIcon>
                              <ListItemText>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={!!validation.workflows}
                                >
                                  <InputLabel id="workflow-task-label">Task</InputLabel>
                                  <Select
                                    labelId="workflow-task-label"
                                    id="workflow-task"
                                    value={w.eventTemplateId || -1}
                                    label="Task"
                                    disabled={disabledForBeingInPast}
                                    onChange={(e) => {
                                      const updatedWorkflows = workflows;
                                      updatedWorkflows[selectedTaskIndex].eventTemplateId = e.target.value;
                                      const foundTemplate = (eventTemplate.children.find((et) => et.id === e.target.value) || {
                                        tags: [],
                                        eventDataDefaultValues: {},
                                      });
                                      updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = foundTemplate.eventDataDefaultValues || {};
                                      updatedWorkflows[selectedTaskIndex].dueDateStatusChangeId = foundTemplate.dueDateStatusChangeId;
                                      updatedWorkflows[selectedTaskIndex].dueDateTime = foundTemplate.dueDateDefaultTime || 0;
                                      updatedWorkflows[selectedTaskIndex].dueDateTimeEndOfDay = foundTemplate.dueDateDefaultTimeEndOfDay || false;

                                      if (foundTemplate.tags.find((t) => t.id === barnTaskTypeTagId)) {
                                        // barn task so put location in tag list
                                        updatedWorkflows[selectedTaskIndex].tagIds = [propLocation.pingumTagId];
                                      } else if (barnHorses.length === 1) {
                                        // horse task, if we only have one barn horse default select it
                                        updatedWorkflows[selectedTaskIndex].tagIds = [barnHorses[0].pingumTagId];
                                      } else {
                                        updatedWorkflows[selectedTaskIndex].tagIds = [];
                                      }
                                      setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                    }}
                                  >
                                    <MenuItem value={-1}> </MenuItem>
                                    {
                                      eventTemplate.children.sort((a, b) => -(b.name).localeCompare(a.name)).map((et) => (
                                        <MenuItem value={et.id} key={`event-template-option-${et.id}`}>{et.name}</MenuItem>
                                      ))
                                    }
                                    {
                                      (permissions.admin || permissions.owner) && (
                                        <Box>
                                          <Divider />
                                          <Box
                                            sx={{
                                              m: 1,
                                              backgroundColor: grey[50],
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <QuestionMarkOutlined color="secondary" />
                                              <Box sx={{ ml: 1 }}>
                                                <Typography component="div" sx={{ fontWeight: 300 }}>Don&#39;t see the task you want to use?</Typography>
                                                <Typography
                                                  sx={{
                                                    fontSize: 13,
                                                    fontWeight: 300,
                                                  }}
                                                >Only tasks made available on this calendar type can be used.
                                                </Typography>
                                              </Box>
                                            </Box>
                                            <Box sx={{ textAlign: 'center' }}>
                                              <Button size="small" onClick={() => { setOpenEditCalendarTypeModal(true); }} startIcon={<Settings />}>
                                                Manage Calendar Event Settings
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                      )
                                    }
                                  </Select>
                                  {!!validation.workflows && <FormHelperText>{validation.workflows}</FormHelperText>}
                                </FormControl>
                              </ListItemText>
                            </ListItem>
                            <ListItem dense sx={{ px: 0 }}>
                              <ListItemIcon>
                                {horseTaskTypeTag && <HorseIcon />}
                                {barnTaskTypeTag && <LocationOn />}
                              </ListItemIcon>
                              <ListItemText>
                                {(!horseTaskTypeTag && !barnTaskTypeTag) && <Alert severity="warning">Select a task type</Alert>}
                                {horseTaskTypeTag
                                  && (
                                    <BarnHorsesAutocomplete
                                      multiple={false}
                                      validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                        ? validation.workflows
                                        : ''}
                                      value={(w.tagIds && workflow.tagIds.length === 1
                                        && barnHorsesMap[w.tagIds[0]] && barnHorsesMap[w.tagIds[0]][0]) || null}
                                      onSelect={(e, newHorse) => {
                                        // take selected barn horses and map to tags
                                        const updatedWorkflows = workflows;
                                        updatedWorkflows[selectedTaskIndex].tagIds = newHorse
                                          ? [parseInt(newHorse.pingumTagId, 10)]
                                          : [];
                                        setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                      }}
                                      limitTags={1}
                                      barnHorses={boardBarnHorses && boardBarnHorses.length > 0
                                        ? boardBarnHorses
                                        : undefined}
                                      disabled={disabledForBeingInPast}
                                    />
                                  )}
                                {
                                  barnTaskTypeTag && (
                                    <LocationsAutocomplete
                                      multiple={false}
                                      validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                        ? validation.workflows
                                        : ''}
                                      value={(w.tagIds && workflow.tagIds.length === 1
                                        && locationsMap[w.tagIds[0]] && locationsMap[w.tagIds[0]][0]) || null}
                                      onSelect={(e, newLocations) => {
                                        // take selected locations and map to tags
                                        const updatedWorkflows = workflows;
                                        updatedWorkflows[selectedTaskIndex].tagIds = newLocations
                                          ? [parseInt(newLocations.pingumTagId, 10)]
                                          : [];
                                        setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                      }}
                                      size="small"
                                      limitTags={1}
                                      disabled={disabledForBeingInPast}
                                    />
                                  )
                                }
                              </ListItemText>
                            </ListItem>
                            <ListItem dense divider sx={{ px: 0 }}>
                              <ListItemIcon><AccountBox /></ListItemIcon>
                              <ListItemText>
                                <BarnUsersAutocomplete
                                  label="Assigned User"
                                  multiple
                                  blurOnSelect
                                  value={getBarnUsersForAssignmentString(w.startingAssignment || '', barnUsersMap)}
                                  onSelect={(e, newBarnUsers) => {
                                    // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].startingAssignment = newBarnUsers.map((bu) => (bu.id
                                      ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                                      : `@[${bu.userFullName || bu}](${null})`)).join('');
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  limitTags={1}
                                  disabled={disabledForBeingInPast}
                                />
                              </ListItemText>
                              <Tooltip title="Assigned users are responsible for doing any work associated with and completing the task in Questri. These users will see the task on their task list in the mobile app and barn board.">
                                <InfoOutlined
                                  sx={{
                                    ml: 1,
                                    fontSize: 20,
                                  }}
                                  color="secondary"
                                />
                              </Tooltip>
                            </ListItem>
                            <ListItem
                              dense
                              divider
                              sx={{ px: 0 }}
                            >
                              <ListItemIcon sx={{ mt: 0.5 }}><AccessAlarm /></ListItemIcon>
                              <ListItemText>
                                <DueDate
                                  workflows={workflows}
                                  setWorkflows={setWorkflows}
                                  selectedTaskIndex={selectedTaskIndex}
                                  entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                />
                              </ListItemText>
                            </ListItem>

                            {
                              horseTaskTypeTag && (
                                <ListItem dense divider sx={{ px: 0 }}>
                                  <ListItemIcon><AttachMoney /></ListItemIcon>
                                  <ListItemText>
                                    <HorseBillablePrice
                                      onChange={(newEventDataDefaults) => {
                                        const updatedWorkflows = workflows;
                                        updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                        setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                      }}
                                      eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                      showHeader={false}
                                      type="inline"
                                      entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                    />
                                  </ListItemText>
                                </ListItem>
                              )
                            }

                            {
                              horseTaskTypeTag && (
                                <ListItem dense sx={{ px: 0 }}>
                                  <ListItemIcon><NoteAlt /></ListItemIcon>
                                  <ListItemText>
                                    <HorseNote
                                      onChange={(newEventDataDefaults) => {
                                        const updatedWorkflows = workflows;
                                        updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                        setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                      }}
                                      eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                      showHeader={false}
                                      type="inline"
                                      entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                    />
                                  </ListItemText>
                                </ListItem>
                              )
                            }
                            <Box
                              sx={{
                                textAlign: 'right',
                                mt: 1,
                              }}
                            >
                              <Button
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  const updatedWorkflows = workflows;
                                  updatedWorkflows.splice(selectedTaskIndex, 1);
                                  setWorkflows(updatedWorkflows);
                                  setSelectedTaskIndex(workflows.length - 1);
                                  setSelectedTaskAnchorEl(null)
                                }}
                              >
                                Remove {horseTaskTypeTag
                                  ? 'Horse'
                                  : 'Location'}
                              </Button>
                            </Box>
                          </Box>
                        </Collapse>
                      )
                    }
                  </Paper>
                </Grid>
              )
            }))
      }
      <Menu
        id="menu-appbar"
        anchorEl={selectedTaskAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorPosition={{
          top: 0,
          left: 0,
        }}
        open={!!selectedTaskAnchorEl}
        onClose={() => {
          if (statuses
            .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
              || eventTemplate.defaultStartStatus.id)).requireComment && !statusComment) {
            return;
          }
          setSelectedTaskAnchorEl(null);
        }}
      >
        <MenuItem>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <TextField
                select
                label="Task Status"
                name="status"
                id="status-select"
                variant="outlined"
                size="small"
                fullWidth
                value={(selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate && eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)}
                onChange={(e) => {
                  if (e.target.value === -1) {
                    window.location.href = '/settings/tasks/statuses'
                  } else {
                    const updatedWorkflows = workflows;
                    updatedWorkflows[selectedTaskIndex].startingStatusId = e.target.value;
                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                  }
                }}
                SelectProps={{
                  renderValue: () => {
                    const status = statuses
                      .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || eventTemplate.defaultStartStatus.id));
                    return (
                      <ListItem sx={{ p: 0 }} dense>
                        <Icon
                          sx={{
                            color: primary[500],
                            mr: 2,
                          }}
                        >{status.icon}
                        </Icon>
                        <ListItemText
                          primary={status.name}
                          secondaryTypographyProps={{ component: 'div' }}
                          secondary={getStatusItemSecondaryText(status, {})}
                        />
                      </ListItem>
                    )
                  },
                }}
              >
                {
                  statuses.sort((a, b) => a.statusOrder - b.statusOrder).map((status) => (
                    <ListItemButton
                      dense
                      key={`status-${status.id}`}
                      value={status.id}
                      button={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) !== status.id}
                      disabled={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) === status.id}
                    >
                      <Icon
                        sx={{
                          mr: 1,
                          color: primary[500],
                        }}
                      >{status.icon}
                      </Icon>
                      <ListItemText
                        primary={status.name}
                        secondaryTypographyProps={{ component: 'div' }}
                        secondary={getStatusItemSecondaryText(status, {})}
                      />
                    </ListItemButton>
                  ))
                }

                {(permissions.admin || permissions.owner) && (
                  <Divider />
                )}
                {(permissions.admin || permissions.owner) && (
                  <ListItemButton
                    dense
                    value={-1}
                  >
                    <Settings color="secondary" sx={{ mr: 1 }} />
                    <ListItemText
                      primary="Manage available task statuses"
                      secondary="Selecting this will take you away from this page, and any changes won't be saved."
                    />
                  </ListItemButton>
                )}
              </TextField>
              <Tooltip title="Done editing status">
                <Button
                  size="small"
                  variant="outlined"
                  disabled={statuses
                    .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                      || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
                  onClick={() => { setSelectedTaskAnchorEl(null); }}
                >
                  Done
                </Button>
              </Tooltip>
            </Box>
            <UserMentionTextField
              value={statusComment}
              label="Task Status Comment"
              rows={2}
              onChange={(e) => setStatusComment(e.target.value)}
              required={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment}
              error={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
              helperText="Leave a comment or message on this task."
            />
          </Box>

        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem
          onClick={() => {
            const updatedWorkflows = workflows;
            updatedWorkflows.splice(selectedTaskIndex, 1);
            setWorkflows(updatedWorkflows);
            setSelectedTaskIndex(workflows.length - 1);
            setSelectedTaskAnchorEl(null)
          }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          Remove Task
        </MenuItem>
      </Menu>
      {
        eventTemplate && eventTemplate.id && (
          <CalendarEventDetailSettingsPage
            modal
            navigate={navigate}
            openModal={openEditCalendarTypeModal}
            passedInModalId={eventTemplate.id}
            onCloseModal={(updatedEventTemplate) => {
              setOpenEditCalendarTypeModal(false);
              if (updatedEventTemplate) { setEventTemplate(updatedEventTemplate) }
            }}
          />
        )
      }
    </Grid>
  );
};

TasksSection.propTypes = {
  eventTemplate: PropTypes.object,
  workflows: PropTypes.array,
  validation: PropTypes.object.isRequired,
  setWorkflows: PropTypes.func,
  taskTagIds: PropTypes.array,
  barnHorses: PropTypes.array,
  disabledForBeingInPast: PropTypes.bool,
  setEventTemplate: PropTypes.func,
};

TasksSection.defaultProps = {
  eventTemplate: {},
  workflows: [],
  setWorkflows: () => { },
  taskTagIds: [],
  barnHorses: [],
  disabledForBeingInPast: false,
  setEventTemplate: () => { },
};

export default TasksSection;
